import React, { useEffect, useRef, useState } from 'react'
import { Button, Form, Input, InputRef, Typography } from 'antd'
import { useIntl } from 'react-intl'

import IntlMessages from '../../../../util/IntlMessages'

const { Paragraph, Link } = Typography

export interface IResetRequestStepProps {
  email: string
  isBusy: boolean
  onSubmit: (email: string) => void
  onEmailChanged: () => void
  onBackToSignin: () => void
}

const ResetRequestStep = ({ email, isBusy, onSubmit, onEmailChanged, onBackToSignin }: IResetRequestStepProps): React.ReactElement => {
  const { formatMessage } = useIntl()
  const [form] = Form.useForm()
  const inputRef = useRef<InputRef | null>(null)
  const [hasTyped, setHasTyped] = useState(false)

  useEffect(() => {
    inputRef.current?.focus()
  }, [])

  return (
    <>
      <Paragraph className="connect-with-email">
        <IntlMessages id="app.email" />
      </Paragraph>
      <Form name="connect-with-email" form={form} layout="horizontal" initialValues={{ email }} onFinish={(values) => onSubmit(values.email)} onFieldsChange={onEmailChanged}>
        <Form.Item
          name="email"
          style={{ width: '100%' }}
          // Half a typed address is not a wrong one, and an untouched field is not one either.
          validateTrigger={hasTyped ? 'onBlur' : []}
          rules={[{ required: true, type: 'email', message: <IntlMessages id="connect.pleaseInputValidEmail" /> }]}
        >
          <Input
            className="email-input data-hj-allow"
            size="large"
            ref={inputRef}
            data-qa="reset-email"
            placeholder={formatMessage({ id: 'app.enterWorkEmail' })}
            onChange={() => setHasTyped(true)}
          />
        </Form.Item>
        <Form.Item>
          <Button size="large" type="primary" htmlType="submit" disabled={isBusy} loading={isBusy} data-qa="reset-request-submit" block>
            <IntlMessages id="signin.sendResetCode" />
          </Button>
        </Form.Item>
      </Form>
      <Paragraph className="auth-sidebar-login">
        <Link onClick={onBackToSignin} data-qa="reset-back-to-signin">
          <IntlMessages id="signin.backToSignin" />
        </Link>
      </Paragraph>
    </>
  )
}

export default ResetRequestStep
